import { CATEGORIES, type TransactionPreset } from '@debtbot/shared';
import { getLocale, t } from '../i18n';
import { formatMoney } from '../lib/format';

export function presetLabel(p: TransactionPreset): string {
  const emoji = p.category ? CATEGORIES[p.category].emoji : CATEGORIES.other.emoji;
  const title =
    p.note ?? (p.category ? CATEGORIES[p.category].label[getLocale()] : t().txKind.expense);
  return `${emoji} ${title} · ${formatMoney({ amount: p.amount, currency: p.currency })}`;
}

export function PresetChips({
  presets,
  disabled,
  onPick,
}: {
  presets: TransactionPreset[];
  disabled?: boolean;
  onPick: (p: TransactionPreset) => void;
}) {
  if (presets.length === 0) return null;
  return (
    <div className="no-scrollbar -mx-4 flex gap-2 overflow-x-auto px-4 pb-1" data-testid="presets">
      {presets.map((p, i) => (
        <button
          key={i}
          type="button"
          disabled={disabled}
          onClick={() => onPick(p)}
          className="shrink-0 rounded-full bg-secondary-bg px-3 py-2 text-sm active:opacity-70 disabled:opacity-50"
        >
          {presetLabel(p)}
        </button>
      ))}
    </div>
  );
}
